module.exports = __webpack_public_path__ + "static/assets/ac1b57b4a9b09160349eb2d7882ca15f.svg";